import { Button } from "@/components/ui/button";
import { ArrowLeft, Stethoscope } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AssessmentHeaderProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  sessionId?: string;
  onBackToHome: () => void;
  isProcessing: boolean;
}

const AssessmentHeader = ({ 
  currentQuestionIndex, 
  totalQuestions, 
  sessionId, 
  onBackToHome, 
  isProcessing 
}: AssessmentHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className="bg-background/95 backdrop-blur-sm border-b border-border/50 sticky top-0 z-50">
      <div className="container mx-auto px-3 py-2 md:px-6 md:py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button 
              onClick={() => navigate("/")}
              className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
            >
              <div className="bg-gray-900 p-1.5 rounded-lg">
                <Stethoscope className="h-4 w-4 text-white" />
              </div>
              <h1 className="text-lg font-bold text-gray-900">AmIOK</h1>
            </button>
            <Button 
              variant="ghost" 
              onClick={onBackToHome}
              className="text-primary hover:text-primary/80 text-sm min-h-[40px] px-2 md:px-4"
              disabled={isProcessing}
            >
              <ArrowLeft className="mr-1 md:mr-2 h-4 w-4" />
              <span className="hidden sm:inline">Back to Home</span>
              <span className="sm:hidden">Back</span>
            </Button>
          </div>
          <div className="flex flex-col sm:flex-row items-end sm:items-center space-y-1 sm:space-y-0 sm:space-x-3">
            <span className="text-xs md:text-sm text-muted-foreground font-medium">
              Question {currentQuestionIndex + 1} of {totalQuestions}
            </span>
            {sessionId && (
              <span className="text-xs text-muted-foreground/70 hidden lg:inline">
                ID: {sessionId.slice(-6)}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AssessmentHeader;